import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "analytics";
const version = "v1";

// customers
export const getCustomerGrowth = async (period) => {
  let URL = `${API_BASE_URL}/${content}/${version}/customers/growth/`;

  if (period) {
    URL += `?period=${period}`;
  }

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error @ get or create customer growth:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied!" };
    }

    throw error;
  }
};
